// Application configuration from runtime environment variables (injected via Caddy templating)
// Falls back to build-time env vars for development, runtime config for production

import STERISLogoPng from '../styles/img/STERIS-Logo.png';

const getRuntimeConfig = () => {
  // Check if runtime config is available (set by Caddy templating in production)
  if (typeof window !== 'undefined' && window.APP_CONFIG) {
    // Verify that Caddy templates were actually processed
    // If VITE_API_URL starts with '{{', it means templates were not processed
    const apiUrl = window.APP_CONFIG.VITE_API_URL;
    if (apiUrl && !apiUrl.startsWith('{{')) {
      // Templates were processed successfully - use runtime config
      return window.APP_CONFIG;
    }
    // Templates were not processed (Windows build) - fall through to defaults
  }

  // Fallback to build-time environment variables (for development)
  return {
    VITE_API_URL: import.meta.env.VITE_API_URL,
    VITE_CLIENT_ID: import.meta.env.VITE_CLIENT_ID,
    VITE_HOSPITAL_NAME: import.meta.env.VITE_HOSPITAL_NAME,
    VITE_HOSPITAL_LOGO: import.meta.env.VITE_HOSPITAL_LOGO,
    VITE_SYNC_SCHEDULE: import.meta.env.VITE_SYNC_SCHEDULE,
    VITE_DEFAULT_LANGUAGE: import.meta.env.VITE_DEFAULT_LANGUAGE,
    ENVIRONMENT: import.meta.env.MODE
  };
};

const config = getRuntimeConfig();

// Determine API URL based on environment
// - Docker/containerized: VITE_API_URL is set via Caddy templates
// - Windows on-prem: Use same origin as the app (API server serves static files)
// - Development: Use localhost:8082
const getApiUrl = () => {
  if (config.VITE_API_URL) {
    return config.VITE_API_URL;
  }

  // Check if we're running in a browser (not SSR)
  if (typeof window !== 'undefined' && window.location) {
    // For Windows on-prem, API is on same origin (Express serves static + API)
    // This handles access via localhost, LAN IP, or hostname
    return window.location.origin;
  }

  // Fallback for development/SSR
  return "http://localhost:8082";
};

const appConfig = {
  // API Configuration
  ApiUrl: getApiUrl(),

  // Client Configuration
  ClientId: config.VITE_CLIENT_ID || "1",
  HospitalName: config.VITE_HOSPITAL_NAME || "STERIS Hospital",
  HospitalLogo: config.VITE_HOSPITAL_LOGO || STERISLogoPng,

  // Application Configuration
  SyncSchedule: config.VITE_SYNC_SCHEDULE || "10",
  DefaultLanguage: config.VITE_DEFAULT_LANGUAGE || "en",

  // Environment
  Environment: config.ENVIRONMENT || "development"
};

export default appConfig;
